"use client";

import { Button, Icon, Image, Link, Text, View } from "@/components";

import useDropdown from "@/hooks/useDropdown";
import { useLayout } from "@/providers";
import cn from "@/utils/cn";

import type { JSX } from "react";

const Notification = ({ className }: { className?: string }): JSX.Element => {
  const { t } = useLayout();
  const notifications: [] = [];
  const { open, ref, toggleOpen } = useDropdown();

  return (
    <View
      ref={ref}
      className={cn("relative shrink-0 flex items-center", className)}
    >
      <Button
        onClick={toggleOpen}
        className="btn-rounded"
        label={t("notifications") || "Notifications"}
      >
        <Icon name="bell:bx:bx" className="text-2xl" />
      </Button>
      <View
        className={`bg-popover border-2 border-border z-[21] rounded-md ltr:origin-top-right rtl:origin-top-left ltr:right-0 rtl:left-0 shadow-lg absolute top-full transition-all duration-300 ${open ? "opacity-100 scale-100 visible" : "opacity-0 scale-0 invisible"}`}
      >
        <View className="flex justify-between items-center lg:px-4 p-3 border-b ">
          <Text type="h5" className="h5">
            {t("notifications")}
          </Text>
          <Link href="/" onClick={toggleOpen} className="text-primary text-sm">
            {t("viewAll")}
          </Link>
        </View>
        <View
          type="ul"
          className="flex flex-col w-[260px] sm:w-[280px] p-4 max-h-[250px] overflow-y-auto"
        >
          {notifications?.map(({ id, img, name, subject }) => (
            <View
              type="li"
              key={id}
              className="flex gap-2 cursor-pointer p-2 rounded-md hover:bg-primary/10 transition duration-300"
            >
              <View className="relative w-12 h-12 shrink-0">
                <Image
                  src={img}
                  alt={name}
                  width={40}
                  height={40}
                  className="rounded-full aspect-square object-cover"
                />
              </View>
              <View className="text-sm">
                <Text className="text-xs">{subject}</Text>
              </View>
            </View>
          ))}
        </View>
      </View>
    </View>
  );
};

export default Notification;
